module.exports = __webpack_public_path__ + "img/Housse_et_chemin.ef97278.jpg";